<p-dialog
  header="Invite User"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: 'min(32rem, 96vw)' }"
  [breakpoints]="{ '575px': '96vw' }"
  appendTo="body"
  [(visible)]="visible"
  (onShow)="reset()"
>
  <form
    id="invite-member-form"
    class="flex flex-col gap-4"
    (ngSubmit)="submit()"
  >
    <div class="flex flex-col gap-1.5">
      <label for="invite-member-email" class="text-sm font-medium">Email</label>
      <input
        id="invite-member-email"
        name="email"
        pInputText
        type="email"
        [(ngModel)]="email"
        placeholder="name@example.com"
        class="w-full"
      />
    </div>
    <div class="flex flex-col gap-1.5">
      <label for="invite-member-role" class="text-sm font-medium"
        >Permission</label
      >
      <p-select
        inputId="invite-member-role"
        name="role"
        [options]="roleOptions()"
        [(ngModel)]="role"
        optionLabel="label"
        optionValue="value"
        class="w-full"
        appendTo="body"
      />
    </div>
  </form>
  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <p-button label="Cancel" severity="secondary" (onClick)="close()" />
      <button
        pButton
        type="submit"
        form="invite-member-form"
        [disabled]="!canInvite"
      >
        <i pButtonIcon class="pi pi-send"></i>
        <span pButtonLabel>Invite</span>
      </button>
    </div>
  </ng-template>
</p-dialog>
